import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import { Lang } from "../../i18n/translations";
import { Colors } from "../../utils/utils.colors";

type Props = {
  variant?: "light" | "dark";
  compact?: boolean;
};

export const LanguageSwitcher: React.FC<Props> = ({ variant = "dark", compact }) => {
  const { lang, setLang, t } = useLanguage();

  const btn = (code: Lang, label: string) => (
    <button
      type="button"
      data-testid={`lang-${code}`}
      onClick={() => setLang(code)}
      style={{
        border: "none",
        cursor: "pointer",
        padding: compact ? "4px 8px" : "6px 12px",
        borderRadius: 6,
        fontSize: compact ? 11 : 12,
        fontWeight: 600,
        letterSpacing: 0.5,
        background: lang === code ? (variant === "light" ? "white" : Colors.primaryColor) : "transparent",
        color: lang === code ? (variant === "light" ? Colors.primaryColor : "white") : variant === "light" ? "rgba(255,255,255,0.85)" : "#555",
        transition: "all 0.2s",
      }}
    >
      {label}
    </button>
  );

  return (
    <div
      data-testid="language-switcher"
      style={{
        display: "inline-flex",
        gap: 2,
        padding: 3,
        borderRadius: 8,
        background: variant === "light" ? "rgba(255,255,255,0.15)" : "#eef0f4",
      }}
      role="group"
      aria-label="Language"
    >
      {btn("fr", t.lang.fr)}
      {btn("en", t.lang.en)}
    </div>
  );
};
